import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { WorkspaceInfo } from '../types/api'
import { persistStorage } from './storage'

interface WorkspaceState {
  activeWorkspaceId: string | null
  workspaces: WorkspaceInfo[]
  setActiveWorkspace: (workspaceId: string | null) => void
  setWorkspaces: (workspaces: WorkspaceInfo[]) => void
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      activeWorkspaceId: null,
      workspaces: [],
      setActiveWorkspace: (workspaceId) =>
        set({ activeWorkspaceId: workspaceId }),
      setWorkspaces: (workspaces) => set({ workspaces }),
    }),
    {
      name: 'chromaframe-workspace',
      version: 1,
      storage: persistStorage('chromaframe-workspace'),
      partialize: (s) => ({ activeWorkspaceId: s.activeWorkspaceId }),
    },
  ),
)
